var map = {
	"./cold_1.png": 1573,
	"./cold_2.png": 1574,
	"./cold_3.png": 1575,
	"./flood_1.png": 1576,
	"./flood_2.png": 1577,
	"./flood_3.png": 1578,
	"./heat_1.png": 1579,
	"./heat_2.png": 1580,
	"./heat_3.png": 1581,
	"./low_visibility_1.png": 1582,
	"./low_visibility_2.png": 1583,
	"./low_visibility_3.png": 1584,
	"./rainfall_1.png": 1585,
	"./rainfall_2.png": 1586,
	"./rainfall_3.png": 1587,
	"./snowfall_1.png": 1588,
	"./snowfall_2.png": 1589,
	"./snowfall_3.png": 1590,
	"./wind_gust_1.png": 1591,
	"./wind_gust_2.png": 1592,
	"./wind_gust_3.png": 1593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1572;